import { render, staticRenderFns } from "./VinculateForms.vue?vue&type=template&id=451da6b1"
import script from "./VinculateForms.vue?vue&type=script&lang=js"
export * from "./VinculateForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports